import _ from "lodash";
import { BigNumber } from "bignumber.js";
export var numAdd = function (num1, num2) {
    var x = BigNumber(num1);
    var result = x.plus(num2);
    return result.toNumber();
};
export var numSub = function (num1, num2) {
    var x = BigNumber(num1);
    var result = x.minus(num2);
    return result.toNumber();
};
export var numMulti = function (num1, num2) {
    if (!num1 || !num2) {
        return 0;
    }
    var x = BigNumber(num1);
    var result = x.multipliedBy(num2);
    return result.toNumber();
};
export var numDiv = function (num1, num2) {
    var x = BigNumber(num1);
    var result = x.div(num2);
    return result.toNumber();
};
export var add = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var arrTemp = [], arg = _.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.apply(arguments);
    arrTemp = arg.map(function (item, index) {
        item = item || "0";
        return parseFloat(item.toString());
    });
    return arrTemp.reduce(numAdd, 0);
};
export var round = function (number, precision) {
    return Math.round(Number(+number + 'e' + precision)) / Math.pow(10, precision);
};
